/**
 * Güney Kore (KRX) hisse verisi.
 *
 * Eskiden var olmayan /api/kr uçlarına gidiyordu; artık backend'in gerçek piyasa
 * uçlarını kullanan ortak adaptör üzerinden çalışır.
 */
import { fetchAsiaQuotes, fetchChartSeries, fetchPeriodChanges } from '@/services/marketAdapter'
import type { AsiaQuote, ChartPoint, PeriodChange } from '@/services/marketAdapter'

export type { AsiaQuote, ChartPoint, PeriodChange }

export const fetchKrQuotes = (symbols: string[]): Promise<Record<string, AsiaQuote>> =>
  fetchAsiaQuotes(symbols)

export const fetchKrChartData = (symbol: string, period: string): Promise<ChartPoint[]> =>
  fetchChartSeries(symbol, period)

export const fetchKrPeriodChanges = (symbols: string[]): Promise<Record<string, PeriodChange>> =>
  fetchPeriodChanges(symbols)
